module.exports = __webpack_public_path__ + "static/media/4.41408bd.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/4.mp3
// module id = PxQv
// module chunks = 112